import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button
} from '@mui/material';

export const DuplicateInstanceDialog = () => (
  <Dialog
    open
    aria-labelledby='alert-dialog-title'
    aria-describedby='alert-dialog-description'
  >
    <DialogTitle id='alert-dialog-title'>
      {"Duplicate Instance Detected"}
    </DialogTitle>
    <DialogContent>
      <DialogContentText id='alert-dialog-description'>
        A duplicate instance of the app was loaded in another tab.
        Please reload this page to continue.
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={() => window.location.reload()} autoFocus>
        Reload
      </Button>
    </DialogActions>
  </Dialog>
);
